/** @jsx jsx */
import { jsx, Field, IconButton } from 'theme-ui'
import Body from '../Typography/Body/Body'
import Search from '../../../icons/Search.svg'

const SearchIcon = () => {
  return (
    <IconButton
      sx={{
        position: 'absolute',
        marginLeft: '0px',
        marginTop: '8px',
      }}
    >
      <img src={Search} alt="Search" />
    </IconButton>
  )
}

function checkForError(error, message) {
  if (error) {
    return (
      <Body
        variant="caption"
        sx={{
          color: '#971D13',
          marginTop: '8px',
        }}
      >
        {message}
      </Body>
    )
  }
}

const StyledLabel = ({
  searchIcon,
  error,
  errorMessage,
  containerProps,
  sx,
  ...props
}) => {
  return (
    <div {...containerProps}>
      {searchIcon && <SearchIcon />}
      <Field
        {...props}
        sx={{
          fontFamily: 'Avenir',
          fontWeight: '300',
          fontSize: '14px',
          lineHeight: '16px',
          border: '1px solid #D1CDC5',
          boxSizing: 'border-box',
          borderRadius: 0,
          paddingLeft: searchIcon && '30px',
          height: '48px',
          ...sx,
        }}
      />
      {checkForError(error, errorMessage)}
    </div>
  )
}

export default StyledLabel
